export default __webpack_public_path__ + "static/Event3-787e30a0b083667ff4249561e2709100.jpg";